<form [formGroup]="configurationFormGeneral">
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-name" class="control-label required">{{ 'i18n.domain.import-configuration.edit.general.name' | translate }}</label>
      <input id="ic-name" type="text" class="form-control" formControlName="name" />
      <app-error-messages [control]="configurationFormGeneral.controls.name"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label class="control-label required">{{'i18n.domain.import-configuration.edit.general.transfer-type' | translate}}</label>
      <ejs-dropdownlist [dataSource]="transferTypes"
                        [fields]="enumDropdownSettings"
                        id="ic-transferType"
                        formControlName="transferType">
        <ng-template #itemTemplate let-data>
          {{data.text | translate}}
        </ng-template>
        <ng-template #valueTemplate let-data>
          <div class="centered">
            <span>{{data.text | translate}}</span>
          </div>
        </ng-template>
      </ejs-dropdownlist>
      <app-error-messages [control]="configurationFormGeneral.controls.transferType"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label class="control-label required">{{ 'i18n.domain.import-configuration.edit.general.active' | translate }}</label>
      <app-yes-no-group-button id="ic-active" formControlName="isActive"></app-yes-no-group-button>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label class="control-label required">{{'i18n.domain.import-configuration.edit.general.import-type' | translate}}</label>
      <ejs-dropdownlist [dataSource]="importTypes"
                        [fields]="enumDropdownSettings"
                        id="ic-importType"
                        formControlName="importType">
        <ng-template #itemTemplate let-data>
          {{data.text | translate}}
        </ng-template>
        <ng-template #valueTemplate let-data>
          <div class="centered">
            <span>{{data.text | translate}}</span>
          </div>
        </ng-template>
      </ejs-dropdownlist>
      <app-error-messages [control]="configurationFormGeneral.controls.importType"></app-error-messages>
    </div>
  </div>
  @if(showUserAssignmentGrid){
    <div class="form-row row">
      <div class="form-group col-12">
        <label class="control-label required">{{ 'i18n.domain.import-configuration.edit.general.grid-title' | translate }}:</label>
        <app-configuration-form-general-grid></app-configuration-form-general-grid>
      </div>
    </div>
  }
</form>
